<template>
    <div>
        <LegalWarningSection title='Preliminar'>
            <p>
                La finalidad de CONEPTUM SL, con NIF B-65946956, es ofrecer una plataforma tecnológica denominada  INMATIC,   que   permite   a   empresas   y   profesionales   procesar   de   forma automática la contabilización de facturas y documentos análogos.
            </p>
            <p>
                Para poder adquirir nuestro producto, tan sólo debes ser usuario de CONEPTUM y nosotros te informaremos de todas las ofertas y promociones que podamos ofrecerte.
            </p>
        </LegalWarningSection>
        <LegalWarningSection title='Generalidades'>
            <p>
                Para poder comprar es necesario registro previo como Usuario de la Web y por este motivo ha de aceptar, sin reservas, las presentes Condiciones Generales de contratación y venta de software. El hecho de ignorar o desconocer las Condiciones Generales, no exime a ningún Cliente de su cumplimiento.          
            </p>
            <p>
                El registro en CONEPTUM es totalmente GRATUITO y se ofrece en calidad de Prestación de Servicios sin contraprestación económica. El Registro supone, por parte del Cliente, la aceptación plena y sin reservas de las condiciones expuestas.
            </p>
            <p>
                Por la presente el Cliente autoriza al tratamiento de sus datos en el marco de la gestión diaria, sus relaciones jurídicas y comerciales. Igualmente se informa al Cliente que le asisten los derechos acceso, rectificación, limitación, portabilidad, oposición y supresión de los datos en virtud de la legislación vigente en materia de protección de datos personales. Para ejercitar estos derechos podrá dirigirse a CONEPTUM, S.L.”, con domicilio en C/Domènech 7-9, Planta 2, Puerta 1, 08012 de Barcelona, con número de NIF: B65946956, Correo electrónico de contacto info@coneptum.com.
            </p>
        </LegalWarningSection>
        <LegalWarningSection title='Seguridad'>
            <p>
                CONEPTUM de conformidad con lo dispuesto en la “Ley de los Servicios de la Sociedad de la Información y Comercio Electrónico” (LSSIce), tiene el deber de retener todos los datos de tráfico relativos a comunicaciones electrónicas, por un periodo máximo de doce meses, imprescindibles para identificar el origen en el momento en que se inició la prestación del servicio. En ningún caso, la obligación de retención de datos afectará al secreto de las comunicaciones.
            </p>
            <p>
                CONEPTUM recibe las direcciones IP de todos los Usuarios debido a que éstas son enviadas por los navegadores cada vez que solicitan acceso a nuestras páginas. Estas direcciones IP se guardan por seguridad en nuestros archivos de Log, quedando a disposición de las autoridades competentes tal y como establece la Ley para, en su caso, identificar el autor o autores de determinados hechos ilegales. La información que se guarda en estos Logs es la dirección IP y la fecha y hora de cada petición realizada a nuestro Servidor con la finalidad de, además de la anteriormente descrita, analizar tendencias, administrar el sistema y recoger información con fines estadísticos.
            </p>
            <p>
                CONEPTUM tiene contratado un servicio de comercio seguro en Internet que comprueba la validez de la tarjeta. El intercambio de estos datos entre el cliente y la tienda on-line se encuentra encriptado mediante una pasarela con su Entidad Financiera bajo el protocolo SSL (Secure Sockets Layer). La información relativa a su tarjeta de crédito no reside ni se transmite a nuestros servidores, siendo un trámite realizado por completo en la Web de su Entidad Financiera, permaneciendo así a salvo de posibles intrusos.
            </p>
        </LegalWarningSection>
        <LegalWarningSection title='Facturación'>
            <p>
                Asimismo, en virtud de lo establecido en el artículo 17 del Reglamento por el que se regulan las obligaciones de facturación, aprobado mediante Real Decreto  CONEPTUM, S.L.”, con domicilio en C/Domènech 7-9, Planta 2, Puerta 1, 08012 de Barcelona, con número   de   NIF:   B65946956o   1.619/2012,   de   30   de   noviembre,   autoriza   que   pueda remitirle facturas y otros documentos mediante la utilización de medios electrónicos.
            </p>
            <p>
                Tal y como se recoge en el Real Decreto antes mencionado, los documentos enviados electrónicamente tienen la misma validez legal que los documentos impresos, siempre que se mantengan en el formato en el que fueron generados electrónicamente.
            </p>
            <p>
                El Cliente expresa su conformidad a la utilización del formato PDF que será el utilizado por CONEPTUM, manifestando que dispone de los medios informáticos necesarios a tal efecto. De la misma forma se establece como medio para la recepción de facturas el Correo electrónico   aportado   en   el   momento   de   registrarse   como   información   de   carácter obligatorio.
            </p>
            <p>
                Mediante la aceptación de las condiciones, las partes excluyen el envío de las mismas en formato papel, salvo solicitud expresa que debe dirigir a CONEPTUM.
            </p>
        </LegalWarningSection>
        <LegalWarningSection title='Códigos de usuario y contraseña'>
            <p>
                La aceptación de las presentes Condiciones Generales, implica que el Cliente será el responsable de la gestión de su cuenta de acceso y contraseña con los que se le concede acceso al sitio Web de CONEPTUM www. coneptum.com Las presentes Condiciones se aplican en complemento a las condiciones de Comercio Electrónico.
            </p>
            <p>
                El Cliente será responsable de mantener la confidencialidad de su código de Usuario y contraseña de su cuenta para acceder al contenido de la Web www.conetpum.com, siendo también único responsable de todas las actividades que ocurran con su Usuario o Cuenta. El Cliente se compromete a notificar inmediatamente cualquier uso no autorizado de su cuenta o de cualquier otra violación de seguridad.  CONEPTUM  no será responsable por ninguna pérdida o daño que resulte de la perdida de la cuenta o de su uso sin autorización del titular de la misma.
            </p>
            <p>
                Cualquier persona que actúe utilizando las claves de acceso de un Cliente de CONEPTUM, ya sea un colaborador, encargado, etc., se considerará como representante del Cliente y con poderes suficientes para actuar como tal y vincularle.
            </p>
        </LegalWarningSection>
        <LegalWarningSection title='Condiciones particulares'>
            <p>
                Asimismo CONEPTUM se reserva el derecho a anular en cualquier momento tanto las operaciones como la cuenta del Cliente.
            </p>
            <p>
                El Cliente se compromete a utilizar la información recibida de forma confidencial y para fines estrictamente propios y a abstenerse de distribuir o reproducir, en todo o en parte, y de cualquier forma, dicha información.
            </p>
            <p>
                CONEPTUM se reserva el derecho a modificar su lista de precios y ofertas sin previo aviso, y los pedidos se aceptarán con reserva de una posible modificación en el precio si se detectan errores tipográficos o de cualquier otro tipo.
            </p>
            <p>
                No obstante, lo anterior, en la factura que CONEPTUM emita, se tomará como base la tarifa en vigor  en  el  momento  del  suministro,  con independencia  del  precio indicado  con anterioridad.
            </p>
        </LegalWarningSection>

        <LegalWarningSection title='Particularidades del producto/servicio'>
            <p>
                INMATIC es una solución que permite mediante un escaneo del documento y de forma automática la contabilización en el programa contable de facturas y tickets de gastos e ingresos y otros documentos análogos.
                <br/>Especificaciones del programa:
                <br/>Contabiliza facturas de profesionales, tickets de caja, facturas con retenciones, iva y otros impuestos.
                <br/>Dentro de las funciones estándares se encuentra la extracción de los siguientes ítems:
                <!-- <br/>- Proveedor/Cliente
                <br/>- nif proveedor y nif cliente
                <br/>- Número de la factura
                <br/>- Fecha de la factura
                <br/>- Fecha de vencimiento de la factura
                <br/>- Base imponible
                <br/>- IVA/IGIC
                <br/>- El total de la factura
                <br/>- La Retención de IRPF -->
                <ul>
                    <li>
                        Proveedor/Cliente
                    </li>
                    <li>
                        nif proveedor y nif cliente
                    </li>
                    <li>
                        Número de la factura
                    </li>
                    <li>
                        Fecha de la factura
                    </li>
                    <li>
                        Fecha de vencimiento de la factura
                    </li>
                    <li>
                        Base imponible
                    </li>
                    <li>
                        IVA/IGIC
                    </li>
                    <li>
                        El total de la factura
                    </li>
                    <li>
                        La Retención de IRPF
                    </li>
                </ul>
            </p>
            <p>
                La contratación del servicio de INMATIC, conlleva la integración de esta funcionalidad al programa que indique el cliente, siempre que no haya alguna incompatibilidad
            </p>
        </LegalWarningSection>
        <LegalWarningSection title='Funcionamiento del programa'>
            <ul>
                <li>
                    INMATIC es un procesador de contabilización de facturas, tickets y/o documentos análogos, en adelante documento, cada vez que se procesa un documento el programa descuenta del saldo de paquete contratado y una vez llega al 90% de documentos contabilizados aparece un pop up en el programa a la vez que se envía un correo electrónico comunicando que  el saldo contratado está a punto de ser agotado.
                </li>
                <li>
                    El paquete de documentos contratados para contabilizar tiene la misma vigencia que el contrato, en ningún caso podrá ser acumulado el saldo no consumido fuera del año de vigencia del contrato.
                </li>
            </ul>
            <br/>
        </LegalWarningSection>
        <LegalWarningSection title='Interrupción del Servicio'>
            <ul>
                <li>
                    a) Coneptum se reserva el derecho a suspender temporalmente la prestación del Servicio para realizar labores de mantenimiento o mejora, notificándolo de forma anticipada al Cliente con al menos 24 horas de antelación.
                </li>
                <li>
                    b) El   cliente   se   compromete   a   facilitar   una   ventana   horaria   de   mantenimiento trimestral y otra mensual para el parcheado general y el crítico respectivamente. 
                </li>
                <li>   
                    c) No obstante, no se notificará de forma previa al Cliente, si dichas labores se realizan como respuesta a un problema grave o que afecte de forma drástica a la seguridad de la infraestructura, y, por tanto, Coneptum deba actuar de forma inmediata sin posibilidad de realizar la notificación previa.
                </li>
                <li>
                    d) Del mismo modo, Coneptum se reserva el derecho a interrumpir temporalmente el Servicio sin previo aviso si observase:
                    <ul>
                        <li>
                            1. Un uso ilícito del Servicio o contrario a lo establecido en los Documentos del Servicio o a sus Políticas de uso.
                        </li>
                        <li>
                            2. Un uso indebido o abusivo del Servicio. 
                        </li>
                    </ul>
                </li>
            </ul>
            <br/>
        </LegalWarningSection>
        <LegalWarningSection title='Soporte técnico'>
            <p>
                Coneptum   ofrece   un   servicio   técnico   base   para   cualquier   cuestión   del   producto INMATIC que le pueda surgir al Cliente, la atención básica es en los días laborales de lunes a viernes dentro del horario comercial de 9 a 18 horas, esta atención será mediante un correo electrónico y Coneptum valorará en cada una de las consultas si es necesario atender por otro medio que no sea el electrónico.
            </p>
            <p>
                Correo electrónico soporte@inmatic.ai
            </p>
        </LegalWarningSection>
        <LegalWarningSection title='Responsabilidades'>
            <ul>
                <li>
                    a) Coneptum se compromete a realizar sus mejores esfuerzos, en el ejercicio de sus funciones, para asegurar el buen funcionamiento de los Servicios pero no será responsable de circunstancias o eventos que se encuentren fuera de su control, tales como el caso fortuito o fuerza mayor.
                </li>
                <li>
                    b) Coneptum no se responsabiliza de fallos en el servicio como consecuencia de caídas del servicio del servidor del cliente derivados de un uso excesivo o erróneo de los recursos del mismo o de los recursos asignados al mismo, ataques externos o de terceras personas, fallos del software o similares.
                </li>
                <li>
                    c) En ningún caso Coneptum será responsable de pérdidas de datos, interrupción de negocio   o   cualesquiera   otros   perjuicios   producidos   por   el   funcionamiento   del Servicio que sea ajeno a la ejecución de Coneptum, o por no cumplir éste con las expectativas del Cliente.
                </li>
                <li>
                    d) Coneptum no se responsabiliza de fallos en el servicio como consecuencia de que el Cliente no haya permitido la realización por parte de Coneptum del mantenimiento trimestral indicado.
                </li>
                <li>
                    e) Ninguna de las Partes será responsable por el incumplimiento del presente Contrato si ello obedece a causas de Fuerza Mayor.
                </li>
                <li>
                    f) Serán considerados como casos de fuerza mayor o caso fortuito, sin carácter limitativo,   el   retraso,   fallo,   suspensión   o   interrupción   de   los   Servicios   como consecuencia de las restricciones de energía, bloqueo de las telecomunicaciones o de la red Internet, acciones u omisiones de terceras personas, operadores de telecomunicaciones   o   compañías   de   servicios,   suministro   o   transportes   o cualesquiera   otras   causas   o   circunstancias   independientes   de   la   voluntad   de Coneptum que impida la ejecución normal del presente contrato.
                </li>
            </ul>
            <br/>
        </LegalWarningSection>
        <LegalWarningSection title='Garantías'>
            <ul>
                <li>
                    a) Coneptum   se  compromete   a  prestar  los servicios  contratados   con  la  máxima diligencia,   utilizando   personal   con   la   debida   experiencia   y   preparación,   en cumplimiento de los procedimientos internos de Coneptum.
                </li>
                <li>
                    b) Se consideran fuera del control de Coneptum, entre otros, los siguientes elementos o recursos:
                    <ul>
                        <li>
                            1. el sistema informático del usuario/s
                        </li>
                        <li>
                            2. El software contable del cliente 
                        </li>
                        <li>
                            3. software de navegación o de conexión y accesorios
                        </li>
                        <li>
                            4. virus, troyanos, gusanos o cualquier otro programa informático hostil, nocivo o perjudicial
                        </li>
                        <li>
                            5. red telefónica conmutada, RDSI, línea punto a punto, cable, satélite y cualquier otra infraestructura de transporte telecomunicaciones.
                        </li>
                    </ul>
                </li>
                <li>
                    c) La garantía de disponibilidad de servicio no es de aplicación en caso de que el cliente haya incumplido alguna de las cláusulas de las presentes.
                </li>
            </ul>
            <br/>
        </LegalWarningSection>
        <LegalWarningSection title='Duración del contrato'>
            <p>
                La   duración   del   Contrato   de   Servicio   será   de   doce   (12)   meses   a   contar   desde   su aceptación y contratación del servicio. Será renovado de forma automático por periodos de igual tiempo, salvo que cualquiera de las Partes notifique a la otra
                <br/>
                Parte su deseo de no renovarlo con una antelación mínima, de 30 días naturales, se acuerda que la notificación a través de correo electrónico para resolver el contrato será aceptada como medio de comunicación valido entre las partes.
            </p>
            <p>
                El servicio se considera un servicio (Saas) software as a service, con lo que se entenderá que, si el servicio no se paga, se deja de obtener el servicio, siempre que el Cliente no atienda al requerimiento de pago del proveedor.
            </p>
        </LegalWarningSection>
        <LegalWarningSection title='Pago, entrega y plazos'>
            <p>
                El servicio se considera un servicio (Saas) software as a service, con lo que en el momento de realizar la compra y se proceda al pago el servicio ya estará disponible.
                <br/>
                El pago se realizará en el momento de contratar el servicio y se realizará por cualquiera de los sistemas que CONEPTUM pone a disposición del cliente.
            </p>
            <p>
                Con la finalización de la compra y la emisión de la factura el cliente recibirá un correo electrónico donde se le indica como acceder a la plataforma y como puede operar para hacer uso del servicio contratado.
            </p>
        </LegalWarningSection>
        <LegalWarningSection title='Derecho de desistimiento'>
            <p>
                El Cliente, a partir del pago y adquisición del servicio, dispondrá de un plazo de 14 días naturales para ejercitar frente a CONEPTUM su desistimiento o revocación de conformidad con la normativa de ventas a distancia regulada en el Texto Refundido de la Ley General de   Defensa   de   Consumidores   y   Usuarios.   Transcurrido   dicho   plazo,   el   servicio   será considerado conforme y aceptado por el Cliente sin que pueda regir ninguna reclamación por desistimiento.
                <br/>
                En el supuesto que el Cliente y dentro del plazo de 14 días quiera ejercer su derecho a desistimiento del servicio deberá hacerlo ante CONEPTUM, mediante el correo electrónico que se encuentra en las presentes condiciones. 
            </p>
            <p>
                En el correo se deberá indicar:
            </p>
            <ul>
                <li>
                    1) Número de la factura de compra
                </li>
                <li>
                    2) Nombre y apellidos o denominación social del cliente
                </li>
                <li>
                    3) Motivación para ejercer el derecho de desistimiento
                </li>
            </ul>
            <br/>
            <p>
                Según   el   artículo   103-Excepciones   al   derecho   de   desistimiento,   del   Real   Decreto Legislativo 1/2007 de 16 de noviembre, por el que se aprueba el texto Refundido de la Ley para la Defensa de los Consumidores y Usuarios y otras leyes complementarias, todos los productos   personalizados   que   CONEPTUM   ofrece   o   pueda   ofrecer,   el   derecho   de desistimiento no será aplicable a los productos personalizados.
            </p>
        </LegalWarningSection>
        <LegalWarningSection title='Formas de pago'>
            <p>
                Tarjeta de crédito, cuando se incluyen los datos de la tarjeta en la web, éstos se encriptan automáticamente y la pasarela de pago seguro enlaza directamente con el banco para realizar el cobro de forma segura.
            </p>
            <p>
                Mediante giro de recibo en la cuenta corriente del cliente, si se usa este sistema se deberá previamente avisar a Coneptum para que introduzca en sus sistemas la cuenta del cliente y proceda la giro de recibo bancario.
            </p>
        </LegalWarningSection>
        <LegalWarningSection title='Legislación y Fuero'>
            <p>
                El   derecho   aplicable   a   estas   condiciones   generales   de   venta,   así   como   a   cualquier controversia relativa al presente contrato, será el derecho español. Cualquier controversia que   se   derive   del   presente   contrato   se   someterá   exclusivamente   a   los   Juzgados   y Tribunales españoles.
            </p>
            <p>
                En el caso de que la parte compradora tenga su domicilio fuera de España, o que se trate de una compraventa realizada por una empresa, ambas partes se someten, con renuncia expresa a cualquier otro fuero, a los Juzgados y Tribunales de la Ciudad de Barcelona (España).
            </p>
            <p>
                Las presentes comprenden el contenido de la Ley del Comercio Electrónico, Ley del Comercio del Minorista y Real Decreto sobre contratación telefónica y electrónica entre otras disposiciones relacionadas.
            </p>
            <p>
                CONEPTUM, S.L." 
                <br/>
                Todos los derechos reservados
            </p>
        </LegalWarningSection>
        
    </div>
</template>

<script>
import LegalWarningSection from "./LegalWarningSection.vue";
import { mapState } from "vuex";

export default {
    name:'SaleTerms',
    components:{
        LegalWarningSection,
    },
    // computed:{
    //     ...mapState("legal",["fullName","shortName","registerData","target","webs","product","contactMail","formToUnsubscribe","address","vatCode"])
    // }
}
</script>

<style lang="scss" scoped>

</style>